export default {

    startLoading(state, message){
        state.loading.active = true;
        state.loading.message = message;
    },

    stopLoading(state){
        state.loading.active = false;
        state.loading.message = null;
    },
	
	UserLogin(state, token){
		state.auth = token;
		localStorage.setItem('accessToken', token);
		axios.defaults.headers.common['Authorization'] = "Bearer " + token;
		
		store.dispatch('fetchPermissions', this.options).then
		((data) => {
			state.permissions = data;
		});
		
		store.dispatch('LoadOperators', this.options).then
		((data) => {
			state.operators = data.operators;
			state.operators.push({text:'allemaal', value:null});
		});
	},
	
	UserLogout(state, token){
		state.auth = false;
		localStorage.removeItem('accessToken');
		axios.defaults.headers.common['Authorization'] = undefined;
	},
	
	UserData(state, profile){
		state.user = profile;
	},
}
